import PhButton from "./PhButton";
import PhSearch from "./PhSearch";
import PhEmpty from "./PhEmpty";
import PhTabs from "./PHTabs";
const PhComponents = {
  // eslint-disable-next-line
  install: function(Vue) {
    Vue.component("ph-button", PhButton);
    Vue.component("ph-search", PhSearch);
    Vue.component("ph-empty", PhEmpty);
    Vue.component("ph-tabs", PhTabs);
  }
};
// 导出
export default PhComponents;
